var _path, _path2, _path3, _path4, _rect, _path5, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1PicSimple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.67134 35.9808C3.3215 35.7476 3.39824 35.213 3.79955 35.0875L25.2 28.3999L44.4573 41.2381C45.157 41.7046 45.0035 42.7738 44.2009 43.0246L23.8 49.3999L3.67134 35.9808Z",
    fill: "#004499"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 42.4V38.55L23.8 45.2V48.7L44.8 42.4Z",
    fill: "#F8F7F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79999 31.2L24.7443 24.3424C25.0325 24.2523 25.346 24.2973 25.5973 24.4648L44.4573 37.0382C45.157 37.5046 45.0035 38.5739 44.2009 38.8247L23.8 45.2L2.79999 31.2Z",
    fill: "#0072FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79999 35.4V31.2L23.8 45.2V49.4L2.79999 35.4Z",
    fill: "#005BCC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.9,
    y: 20,
    width: 25.2,
    height: 15.4,
    fill: "#001C33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4243 13.7117C23.194 13.4478 23.5789 13.3158 23.9731 13.2634C24.3228 13.217 24.6772 13.217 25.0269 13.2634C25.4211 13.3158 25.806 13.4478 26.5757 13.7117L44.5856 19.8865C45.9353 20.3493 46.6102 20.5807 46.7961 20.9239C46.9569 21.2209 46.9569 21.5791 46.7961 21.8761C46.6102 22.2193 45.9353 22.4507 44.5856 22.9135L26.5757 29.0883C25.806 29.3522 25.4211 29.4842 25.0269 29.5366C24.6772 29.583 24.3228 29.583 23.9731 29.5366C23.5789 29.4842 23.194 29.3522 22.4243 29.0883L4.41441 22.9135C3.06465 22.4507 2.38977 22.2193 2.20394 21.8761C2.04313 21.5791 2.04313 21.2209 2.20394 20.9239C2.38977 20.5807 3.06465 20.3493 4.41441 19.8865L22.4243 13.7117Z",
    fill: "#3D4851"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5,
    cy: 35.3999,
    rx: 12.6,
    ry: 4.2,
    fill: "#001C33"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1PicSimple);
export default __webpack_public_path__ + "static/media/1pic_simple.b4eb02c0.svg";
export { ForwardRef as ReactComponent };